import classNames from "classnames";
import React, { FC, useCallback } from "react";
import { Text } from "../text";
import { DateTime, DateTimeProps } from "./date-time";
import { CSS_CLASSES } from "./date-time-input-css-classes";
export interface DateRangeOwnProps {
  onDateSelect: (startDate: Date | null, endDate?: Date | null) => void;
  rangeClassName?: string;
  startRangeMaxDate?: Date;
  startRangeMinDate?: Date;
  endRangeMaxDate?: Date;
  endRangeMinDate?: Date;
  "data-testid"?: any;
}

export type DateRangeToDatePassThroughProps = Omit<DateTimeProps, "onDateSelect">;

export type DateRangeProps = DateRangeOwnProps & DateRangeToDatePassThroughProps;

export const DateRange: FC<DateRangeProps> = ({
  id,
  startDate,
  endDate,
  onDateSelect,
  rangeClassName,
  startRangeMaxDate,
  startRangeMinDate,
  endRangeMaxDate,
  endRangeMinDate,
  ...rest
}) => {
  const onStartDateSelect = useCallback(
    (date: Date) => {
      onDateSelect(date, endDate);
    },
    [endDate, onDateSelect]
  );

  const onEndDateSelect = useCallback(
    (date: Date) => {
      onDateSelect(startDate as Date, date);
    },
    [onDateSelect, startDate]
  );

  const dateRangeClassNames = classNames(CSS_CLASSES.DATE_TIME_INPUT_RANGE_WRAPPER, rangeClassName);
  const { "data-testid": dataTestId, ...restProps } = rest;

  return (
    <div className={dateRangeClassNames} data-testid={dataTestId}>
      <DateTime
        {...restProps}
        id={id}
        selectedDate={startDate as Date}
        onDateSelect={onStartDateSelect as any}
        selectsStart={true}
        selectsEnd={false}
        startDate={startDate}
        endDate={endDate}
        withTime={false}
        onlyTime={false}
        onlyDate={true}
        dateInputClassName={CSS_CLASSES.DATE_TIME_INPUT_RANGE_START_INPUT}
        maxDate={startRangeMaxDate}
        minDate={startRangeMinDate}
      />
      <div className={CSS_CLASSES.DATE_TIME_INPUT_RANGE_DIVIDER}>
        <Text variant="body-short">:</Text>
      </div>
      <DateTime
        {...restProps}
        selectedDate={endDate as Date}
        onDateSelect={onEndDateSelect as any}
        selectsStart={false}
        selectsEnd={true}
        startDate={startDate}
        endDate={endDate}
        withTime={false}
        onlyTime={false}
        onlyDate={true}
        id={`s-${id}`}
        dateInputClassName={CSS_CLASSES.DATE_TIME_INPUT_RANGE_END_INPUT}
        maxDate={endRangeMaxDate}
        minDate={endRangeMinDate}
      />
    </div>
  );
};
